import React from 'react';
import CheckboxPill from '../checkbox_pill';

import styles from './index.module.css';

const CheckboxPillGroup = ({ name, options, values, onToggle, ariaLabel }) => {
  const set = new Set(values || []);
  return (
    <div className={styles.group} role='group' aria-label={ariaLabel}>
      {options.map((opt, index) => (
        <CheckboxPill
          key={`${index}:${opt.value}`}
          name={name}
          value={opt.value}
          label={opt.label}
          checked={set.has(opt.value)}
          onChange={onToggle}
        />
      ))}
    </div>
  );
};

export default CheckboxPillGroup;
